import React, { useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { COUNTRIES } from "@/data/countries";

const FIELDS = [
  ["account_holder", "Account holder name", true], ["wise_email", "Wise account email (optional)", false],
  ["iban", "IBAN (EU/UK)", false], ["swift_bic", "SWIFT / BIC", false],
  ["account_number", "Account number (non-IBAN countries)", false], ["routing_code", "Routing / sort / IFSC code", false],
  ["tax_id", "Tax ID / VAT (optional)", false],
];

export const PayoutDetailsForm = ({ initial, onSaved }) => {
  const [f, setF] = useState({ account_holder: "", wise_email: "", currency: "EUR", country: "", iban: "", swift_bic: "", account_number: "", routing_code: "", address: "", tax_id: "", ...(initial || {}) });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await api.put("/ambassadors/me/payout-details", { ...f, wise_email: f.wise_email || null }); toast.success("Payout details saved"); onSaved?.(); }
    catch (ex) { toast.error(formatApiError(ex.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <form onSubmit={submit} className="space-y-3" data-testid="payout-details-form">
      <div className="grid sm:grid-cols-2 gap-3 [&>*]:min-w-0 [&>*]:w-full">
        {FIELDS.map(([k, label, req]) => (
          <input key={k} className="field" required={req} placeholder={label} value={f[k] || ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`payout-${k}`}/>
        ))}
        <select className="field" required value={f.country} onChange={(e) => setF({ ...f, country: e.target.value })} data-testid="payout-country"><option value="">Bank country…</option>{COUNTRIES.map((c) => <option key={c}>{c}</option>)}</select>
        <select className="field" value={f.currency} onChange={(e) => setF({ ...f, currency: e.target.value })} data-testid="payout-currency">{["EUR", "GBP", "USD", "CHF", "AED", "SAR", "INR", "AUD", "CAD"].map((c) => <option key={c}>{c}</option>)}</select>
      </div>
      <input className="field w-full" required minLength={5} placeholder="Account holder address" value={f.address} onChange={(e) => setF({ ...f, address: e.target.value })} data-testid="payout-address"/>
      <p className="text-xs text-zinc-500">Commission is calculated in EUR and paid via Wise Business. Wise converts to your currency at its rate. Provide an IBAN, an account number or your Wise email.</p>
      <button disabled={busy} className="btn-ink px-5 py-2 rounded-full text-sm font-semibold disabled:opacity-60" data-testid="payout-save">{busy ? "Saving…" : "Save payout details"}</button>
    </form>
  );
};
